"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cyanish = exports.indigray = exports.greenish = void 0;
exports.greenish = {
    "50": "#F3F8FA",
    "100": "#EEEFF2",
    "200": "#E4EBF2",
    "300": "#C1D0D5",
    "400": "#99A8AF",
    "500": "#6E7D84",
    "600": "#4E5D64",
    "700": "#384850",
    "800": "#212C34",
    "900": "#10161B",
    "950": "#020304",
};
exports.indigray = {
    "50": "#FAFAFE",
    "100": "#F5F5F9",
    "200": "#E7E7F0",
    "300": "#D6D6E1",
    "400": "#A8A8B8",
    "500": "#6E6E81",
    "600": "#4D4D5F",
    "700": "#3A3A4B",
    "800": "#1F1F31",
    "900": "#121220",
    "950": "#02020D",
};
exports.cyanish = {
    "50": "#F8F9FC",
    "100": "#E1F5FF",
    "200": "#E2EBF5",
    "300": "#CBDAEE",
    "400": "#94A3B8",
    "500": "#647E95",
    "600": "#475569",
    "700": "#334B5F",
    "800": "#14293B",
    "900": "#05172A",
    "950": "#000414",
};
